@if (paginator.state$ | async; as paginatorState) {
	<div
		name="table-container"
		class="bg-base-100 card border-base-200 overscroll-none border shadow-sm"
	>
		<div class="border-base-200 flex items-center justify-end gap-2 border-b p-3">
			<button
				class="btn btn-xs btn-outline"
				(click)="toggleSelectAllTranslations()"
				[disabled]="!hasTranslations() || isSelectingAll()"
				[translate]
			>
				{{ areAllTranslationsSelected() ? 'Unselect all' : 'Select all' }}
			</button>
			@if (selectedTranslationsCount() > 0) {
				<span class="text-base-content/60 text-xs font-medium"> {{ selectedTranslationsCount() }} selected </span>
				<button
					class="btn btn-xs btn-error btn-outline"
					(click)="deleteSelectedTranslations()"
					[translate]
				>
					Delete selected
				</button>
			}
		</div>
		<table
			name="table-body"
			class="table w-full"
		>
			<thead class="bg-base-200/50 text-base-content/60 text-xs font-bold tracking-wider uppercase">
				<tr>
					<th class="selection-column w-12 text-center">
						<div class="flex justify-center">
							{{ selectedTranslationsCount() ? selectedTranslationsCount() : '' }}
						</div>
					</th>
					<th class="py-4">
						<div class="flex flex-col items-center gap-2">
							<span class="text-nowrap">in</span>
							<div class="join flex">
								<button
									class="btn btn-ghost btn-xs join-item"
									(click)="paginator.setOrderingBy('language_source')"
									title="Sort"
								>
									↑↓
								</button>
								<button
									class="btn btn-ghost btn-xs join-item"
									[class.btn-active]="displaySearchByFields$_['language_source']"
									(click)="toggleSearchByField('language_source')"
									title="Search"
								>
									🔎
								</button>
							</div>
						</div>

						@if (displaySearchByFields$_['language_source']) {
							<div class="mt-2">
								<select
									class="select select-bordered select-xs w-full max-w-xs"
									[(ngModel)]="filterByFields$_['language_source']"
								>
									<option value="">All</option>
									@for (lang of availableLanguages; track lang) {
										<option [value]="lang">{{ lang }}</option>
									}
								</select>
							</div>
						}
					</th>
					<th class="py-4">
						<div class="flex flex-col items-center gap-2">
							<span class="text-nowrap">out</span>
							<div class="join">
								<button
									class="btn btn-ghost btn-xs join-item"
									(click)="paginator.setOrderingBy('language_target')"
									title="Sort"
								>
									↑↓
								</button>
								<button
									class="btn btn-ghost btn-xs join-item"
									[class.btn-active]="displaySearchByFields$_['language_target']"
									(click)="toggleSearchByField('language_target')"
									title="Search"
								>
									🔎
								</button>
							</div>
						</div>
						@if (displaySearchByFields$_['language_target']) {
							<div class="mt-2">
								<select
									class="select select-bordered select-xs w-full max-w-xs"
									[(ngModel)]="filterByFields$_['language_target']"
								>
									<option value="">All</option>
									@for (lang of availableLanguages; track lang) {
										<option [value]="lang">{{ lang }}</option>
									}
								</select>
							</div>
						}
					</th>
					<th class="py-4">
						<div class="flex flex-col items-center gap-2">
							<span class="text-nowrap">sentence</span>
							<div class="join">
								<button
									class="btn btn-ghost btn-xs join-item"
									(click)="paginator.setOrderingBy('source_content')"
									title="Sort"
								>
									↑↓
								</button>
								<button
									class="btn btn-ghost btn-xs join-item"
									[class.btn-active]="displaySearchByFields$_['source_content']"
									(click)="toggleSearchByField('source_content')"
									title="Search"
								>
									🔎
								</button>
							</div>
						</div>
						@if (displaySearchByFields$_['source_content']) {
							<div class="mt-2">
								<input
									class="input input-bordered input-xs focus:input-primary w-full max-w-xs"
									type="text"
									placeholder="Search..."
									[(ngModel)]="filterByFields$_['source_content']"
								/>
							</div>
						}
					</th>
					<th class="py-4">
						<div class="flex flex-col items-center gap-2">
							<span class="text-nowrap">translation</span>
							<div class="join">
								<button
									class="btn btn-ghost btn-xs join-item"
									(click)="paginator.setOrderingBy('translated_content')"
									title="Sort"
								>
									↑↓
								</button>
								<button
									class="btn btn-ghost btn-xs join-item"
									[class.btn-active]="displaySearchByFields$_['translated_content']"
									(click)="toggleSearchByField('translated_content')"
									title="Search"
								>
									🔎
								</button>
							</div>
						</div>
						@if (displaySearchByFields$_['translated_content']) {
							<div class="mt-2">
								<input
									class="input input-bordered input-xs focus:input-primary w-full max-w-xs"
									type="text"
									placeholder="Search..."
									[(ngModel)]="filterByFields$_['translated_content']"
								/>
							</div>
						}
					</th>
					<th class="py-4">
						<div class="flex flex-col items-center gap-2">
							<span class="text-nowrap">context</span>
							<div class="join">
								<button
									class="btn btn-ghost btn-xs join-item"
									(click)="paginator.setOrderingBy('translation_context')"
									title="Sort"
								>
									↑↓
								</button>
								<button
									class="btn btn-ghost btn-xs join-item"
									[class.btn-active]="displaySearchByFields$_['translation_context']"
									(click)="toggleSearchByField('translation_context')"
									title="Search"
								>
									🔎
								</button>
							</div>
						</div>
						@if (displaySearchByFields$_['translation_context']) {
							<div class="mt-2">
								<input
									class="input input-bordered input-xs focus:input-primary w-full max-w-xs"
									type="text"
									placeholder="Search..."
									[(ngModel)]="filterByFields$_['translation_context']"
								/>
							</div>
						}
					</th>
					<th class="py-4">
						<div class="flex flex-col items-center gap-2">
							<span class="text-nowrap">traductor</span>
							<div class="join">
								<button
									class="btn btn-ghost btn-xs join-item"
									(click)="paginator.setOrderingBy('translator')"
									title="Sort"
								>
									↑↓
								</button>
								<button
									class="btn btn-ghost btn-xs join-item"
									[class.btn-active]="displaySearchByFields$_['translator']"
									(click)="toggleSearchByField('translator')"
									title="Search"
								>
									🔎
								</button>
							</div>
						</div>
						@if (displaySearchByFields$_['translator']) {
							<div class="mt-2">
								<input
									class="input input-bordered input-xs focus:input-primary w-full max-w-xs"
									type="text"
									placeholder="Search..."
									[(ngModel)]="filterByFields$_['translator']"
								/>
							</div>
						}
					</th>
					<th class="py-4">
						<div class="flex flex-col items-center gap-2">
							<span class="text-nowrap">date</span>
							<button
								class="btn btn-ghost btn-xs"
								(click)="paginator.setOrderingBy('time_created')"
							>
								↑↓
							</button>
						</div>
					</th>
					<th class="py-4 text-center">
						<div class="flex flex-col items-center gap-2">
							<span class="text-nowrap">actions</span>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				@for (translation of paginatorState.itemsOnCurrentPage; track translation?.id) {
					<!--  -->

					@if (translation) {
						<tr
							[tabIndex]="0"
							(click)="processClick(translation)"
							(keyup.enter)="processClick(translation)"
							class="hover:bg-base-200/50 cursor-pointer transition-colors duration-150"
							[ngClass]="{ 'bg-primary/10': itemsSelector.isSelected(translation) }"
						>
							<td class="text-center">
								<div
									class="flex justify-center"
									(click)="$event.stopImmediatePropagation(); itemsSelector.toggle(translation)"
									(keydown)="(undefined)"
									tabindex="0"
								>
									<input
										class="checkbox checkbox-primary checkbox-sm"
										[name]="'selectedItems' + translation.id"
										type="checkbox"
										[checked]="itemsSelector.isSelected(translation)"
										tabindex="0"
									/>
								</div>
							</td>
							<!-- language source -->
							<td>
								<div class="badge badge-ghost uppercase">{{ translation.languageSource || '-' }}</div>
							</td>
							<!-- language target -->
							<td>
								<div class="badge badge-outline uppercase">{{ translation.languageTarget || '-' }}</div>
							</td>
							<!-- original sentence (sourceContent) -->
							<td>
								<pre class="max-w-sm text-sm whitespace-pre-wrap"
									>{{ translation.sourceContent }}
								</pre
								>
							</td>
							<!-- translated sentence (translatedContent) -->
							<td>
								@if (translation.translatedContent) {
									<pre class="max-w-sm text-sm whitespace-pre-wrap">
									{{ translation.translatedContent }}
									</pre
									>
								} @else {
									<button
										class="btn btn-xs btn-primary"
										(click)="requestTranslation(translation)"
									>
										Request
									</button>
								}
							</td>
							<td>
								<pre class="max-w-sm text-sm whitespace-pre-wrap">{{
									translation.translationContext || '-'
								}}</pre>
							</td>
							<!-- translator (e.g: argos, manual, google...) -->
							<td>{{ translation.translator || '-' }}</td>
							<td>
								<div class="text-base-content/60 text-xs">
									{{ translation.timeCreated | date: 'full' }}
								</div>
							</td>
							<td class="text-center">
								<div class="flex flex-col items-center justify-center gap-2">
									<button
										class="btn btn-xs btn-outline"
										(click)="$event.stopImmediatePropagation(); duplicateTranslation(translation)"
										[translate]
									>
										Duplicate
									</button>
									<button
										class="btn btn-xs btn-error btn-outline"
										(click)="$event.stopImmediatePropagation(); deleteTranslation(translation)"
										[translate]
									>
										Delete
									</button>
								</div>
							</td>
						</tr>
					} @else {
						<tr>
							<td
								colspan="9"
								class="text-center"
							>
								<span class="loading loading-spinner loading-md text-primary"></span>
							</td>
						</tr>
					}
				} @empty {
					<tr>
						<td
							colspan="9"
							class="text-base-content/50 py-12 text-center italic"
						>
							{{ 'Nothing here' | translate | async }}
						</td>
					</tr>
				}
			</tbody>
		</table>
		<lib-table-paginator [paginator]="paginator" />
	</div>
}
